import { PRODUCT } from '@/utils/environment'
import { getCrossListedProducts } from './compatibility'

// Catalogue slugs for the integrations listed on chatbot.com/integrations.
// Apps named "for LiveChat" (e.g. slack-for-livechat) stay out: their pages describe the LiveChat plugin.
const chatbotIntegrationSlugs = new Set([
  'chatbot',
  'helpdesk',
  'facebook-messenger',
  'messenger',
  'whatsapp',
  'whatsapp-business',
  'whatsapp-business-dev',
  'shopify',
  'shopify-live-chat',
  'shopify-20',
  'woocommerce',
  'wordpress',
  'webflow',
  'webflow-1',
  'klaviyo',
  'twilio',
  'zapier',
])

export const worksWithChatBot = (app) =>
  getCrossListedProducts(app).includes(PRODUCT.ChatBot) ||
  chatbotIntegrationSlugs.has(app?.slug)
